//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["controlItem"],
  data() {
    return {
      date: '',
      show: false,
      type:'range'//选择类型:single表示选择单个日期，multiple表示选择多个日期，range表示选择日期区间
    };
  },

  created() {
    // if(this.controlItem && this.controlItem.HelperText){
    //   this.RightIcon = "question-o";
    //   console.log("this.RightIcon",this.RightIcon);
    // }
  },

  methods: {
    async doEvent() {
      var $e = this.$cmd.checkEvent(this.controlItem, "OnChange");
      if (!$e) return;

      var $cmd = $e.Cmd;
      if (!$cmd) return;

      var url = $cmd.CommandText;
      await this.$parent.$repostForm(url);
      return;
    },

    onInput(value) {
      //console.log("onInput---value",value);
    },

    async onBlur(event) {
      console.log("onBlur---onBlur", event);
      this.doEvent();
    },

    onHelpIconClick() {
      if (this.controlItem && this.controlItem.HelperText) {
        this.$msg.toast(this.controlItem.HelperText);
      } else {
        this.$msg.toast("没有找到帮助信息");
      }
    },

     formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      const [start, end] = date;
      this.show = false;
      this.date = `${this.formatDate(start)} - ${this.formatDate(end)}`;
    }
  }
};
